<template>
  <transition name="bpv-slide">
    <div v-if="visible" class="bpv-popup">
      <div class="bpv-head" @click="minimized = !minimized">
        <span class="bpv-title">
          <v-icon small color="red" v-if="failed">mdi-alert-circle</v-icon>
          <v-icon small color="orange" v-else-if="stale">mdi-help-circle</v-icon>
          <v-icon small color="green" v-else-if="done">mdi-check-circle</v-icon>
          <v-icon small color="#757575" v-else>mdi-send</v-icon>
          <span class="bpv-title-text">ส่งบรอดแคสต์</span>
          <span class="bpv-title-pct" v-if="!done && !failed && !stale">{{ pct || 0 }}%</span>
        </span>
        <span class="bpv-head-actions">
          <v-icon small color="#757575">{{ minimized ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
          <v-icon small color="#757575" @click.stop="close">mdi-close</v-icon>
        </span>
      </div>

      <div v-show="!minimized" class="bpv-body">
        <div class="bpv-status-row">
          <v-progress-circular
            v-if="!done && !failed && !stale"
            indeterminate
            :size="18"
            :width="2"
            color="#1b437c"
          ></v-progress-circular>
          <v-icon v-if="done" color="green">mdi-check-circle</v-icon>
          <v-icon v-if="failed" color="red">mdi-alert-circle</v-icon>
          <v-icon v-if="stale" color="orange">mdi-help-circle</v-icon>
          <span class="bpv-label">{{ label }}</span>
        </div>

        <div class="bpv-bar-row" v-if="!failed && !stale">
          <div class="bpv-bar">
            <div
              class="bpv-bar-fill"
              :class="{ 'bpv-bar-done': done }"
              :style="{ width: (pct || 0) + '%' }"
            ></div>
          </div>
          <span class="bpv-pct">{{ pct || 0 }}%</span>
        </div>

        <div class="bpv-hint" v-if="!done && !failed && !stale">
          ปิดหน้านี้หรือไปทำงานอื่นได้เลย ระบบส่งต่อให้เองจนจบ
        </div>

        <div class="bpv-skip" v-if="skipped > 0">
          <div class="bpv-skip-head">
            ข้าม {{ skipped }} รายชื่อ เพราะไม่ใช่ LINE userId ที่ใช้ส่งได้
            <span class="bpv-skip-toggle" @click="showSkipped = !showSkipped">
              {{ showSkipped ? 'ซ่อน' : 'ดูรายชื่อ' }}
            </span>
          </div>
          <div class="bpv-skip-list" v-if="showSkipped">
            <div v-for="uid in skippedIds" :key="uid" class="bpv-skip-item">{{ uid }}</div>
          </div>
          <div class="bpv-skip-note">
            LINE รับเฉพาะ userId รูปแบบ U + ตัวอักษร/ตัวเลข 32 ตัว ถ้ามีรายชื่อผิดปนไปแม้ตัวเดียว LINE จะปฏิเสธทั้งชุด ระบบจึงคัดออกให้ก่อนส่ง
          </div>
        </div>

        <div class="bpv-actions" v-if="done || failed || stale">
          <v-btn small text color="#1b437c" @click="goReport">
            ไปหน้ารายงาน{{ failed || stale ? ' (กดส่งใหม่ได้)' : '' }}
          </v-btn>
        </div>
      </div>

      <div v-show="minimized" class="bpv-minibar">
        <div
          class="bpv-bar-fill"
          :class="{ 'bpv-bar-done': done, 'bpv-bar-failed': failed || stale }"
          :style="{ width: failed || stale ? '100%' : (pct || 0) + '%' }"
        ></div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'

const STORAGE_KEY = 'bpvProgressActive'
const POLL_MS = 2500
const MAX_WAIT_MS = 25 * 60 * 1000
const ERROR_HOLD_MS = 2 * 60 * 1000

export default {
  name: 'BroadcastProgressPopup',
  data () {
    return {
      visible: false,
      minimized: false,
      broadcastId: null,
      step: '',
      label: '',
      pct: 0,
      done: false,
      failed: false,
      stale: false,
      alreadySent: false,
      skipped: 0,
      skippedIds: [],
      sentCount: 0,
      showSkipped: false,
      timer: null,
      errorTimer: null,
      startedTs: 0
    }
  },
  created () {
    this.$root.$on('bpv-progress-start', this.start)
  },
  mounted () {
    let saved = null
    try {
      saved = JSON.parse(localStorage.getItem(STORAGE_KEY))
    } catch (e) {
      saved = null
    }
    if (saved && saved.id) {
      this.start({ id: saved.id })
    }
  },
  beforeDestroy () {
    this.$root.$off('bpv-progress-start', this.start)
    this.stopTimer()
    this.clearErrorTimer()
  },
  methods: {
    start (payload) {
      if (!payload || !payload.id) return
      this.stopTimer()
      this.clearErrorTimer()
      this.broadcastId = String(payload.id)
      this.visible = true
      this.minimized = false
      this.step = 'queued'
      this.label = 'รับคำสั่งแล้ว กำลังเริ่มส่ง'
      this.pct = 5
      this.done = false
      this.failed = false
      this.stale = false
      this.alreadySent = false
      this.skipped = 0
      this.skippedIds = []
      this.sentCount = 0
      this.showSkipped = false
      this.startedTs = Date.now()
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ id: this.broadcastId }))
      } catch (e) {}
      this.timer = setInterval(this.poll, POLL_MS)
      this.poll()
    },
    async poll () {
      if (!this.DNS_IP || !this.broadcastId) return
      if (Date.now() - this.startedTs > MAX_WAIT_MS) {
        this.stale = true
        this.label = 'รอนานผิดปกติ — เช็คสถานะจริงได้ที่หน้ารายงาน'
        this.finish()
        return
      }
      try {
        const res = await axios.get(
          this.DNS_IP + '/broadcast/progress?id=' + this.broadcastId
        )
        const d = res.data || {}
        if (!d.status || !d.progress) return
        const p = d.progress
        if (typeof p.pct === 'number') this.pct = p.pct
        if (p.label) this.label = p.label
        if (p.step) this.step = p.step
        if (typeof p.skipped === 'number') this.skipped = p.skipped
        if (Array.isArray(p.skippedIds)) this.skippedIds = p.skippedIds
        if (typeof p.sentCount === 'number') this.sentCount = p.sentCount
        this.alreadySent = !!p.alreadySent
        if (p.done) {
          this.done = true
          this.pct = 100
          this.finish()
        } else if (p.failed) {
          this.failed = true
          this.finish()
        } else if (p.stale) {
          this.stale = true
          this.finish()
        }
      } catch (e) {
        console.log('bpv progress poll error', e)
      }
    },
    finish () {
      this.stopTimer()
      try {
        localStorage.removeItem(STORAGE_KEY)
      } catch (e) {}
      if (this.failed || this.stale) {
        this.holdErrorThenClose()
      }
    },
    holdErrorThenClose () {
      if (this.errorTimer) {
        clearTimeout(this.errorTimer)
      }
      this.errorTimer = setTimeout(() => {
        this.errorTimer = null
        this.visible = false
      }, ERROR_HOLD_MS)
    },
    stopTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    clearErrorTimer () {
      if (this.errorTimer) {
        clearTimeout(this.errorTimer)
        this.errorTimer = null
      }
    },
    close () {
      this.finish()
      this.clearErrorTimer()
      this.visible = false
    },
    goReport () {
      if (this.$route.path !== '/Reports/reportBroadcast') {
        this.$router.push('/Reports/reportBroadcast')
      }
      if (this.done || this.failed || this.stale) {
        this.visible = false
      }
    }
  }
}
</script>

<style scoped>
.bpv-popup {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: 340px;
  max-width: calc(100vw - 24px);
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.28);
  overflow: hidden;
  z-index: 10500;
  font-family: 'Kanit', sans-serif;
}
.bpv-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  color: #333333;
  padding: 10px 12px 8px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  user-select: none;
}
.bpv-title {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
}
.bpv-title-text {
  margin-left: 4px;
}
.bpv-title-pct {
  margin-left: 6px;
  font-size: 12px;
  color: #888888;
}
.bpv-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bpv-body {
  padding: 12px 14px 10px 14px;
}
.bpv-status-row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 24px;
}
.bpv-label {
  font-size: 13px;
  color: #333333;
  line-height: 1.35;
  margin-left: 6px;
}
.bpv-bar-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
.bpv-bar {
  flex: 1;
  height: 8px;
  background: #e6ebf2;
  border-radius: 4px;
  overflow: hidden;
}
.bpv-bar-fill {
  height: 100%;
  background: #1b437c;
  border-radius: 4px;
  transition: width 0.6s ease;
}
.bpv-bar-done {
  background: #2e9e5b;
}
.bpv-bar-failed {
  background: #d9534f;
}
.bpv-pct {
  font-size: 12px;
  color: #555555;
  min-width: 34px;
  text-align: right;
}
.bpv-hint {
  margin-top: 8px;
  font-size: 11px;
  color: #888888;
}
.bpv-skip {
  margin-top: 10px;
  padding: 8px 10px;
  background: #fbfbfb;
  border: 1px solid #eeeeee;
  border-radius: 6px;
}
.bpv-skip-head {
  font-size: 12px;
  color: #a8710a;
}
.bpv-skip-toggle {
  margin-left: 6px;
  color: #1b437c;
  cursor: pointer;
  text-decoration: underline;
}
.bpv-skip-list {
  margin-top: 6px;
  max-height: 96px;
  overflow-y: auto;
}
.bpv-skip-item {
  font-size: 11px;
  color: #666666;
  font-family: monospace;
  word-break: break-all;
}
.bpv-skip-note {
  margin-top: 6px;
  font-size: 11px;
  color: #999999;
  line-height: 1.35;
}
.bpv-actions {
  margin-top: 8px;
  text-align: right;
}
.bpv-minibar {
  height: 5px;
  background: #e6ebf2;
}
.bpv-slide-enter-active,
.bpv-slide-leave-active {
  transition: all 0.25s ease;
}
.bpv-slide-enter,
.bpv-slide-leave-to {
  opacity: 0;
  transform: translateY(12px);
}
</style>



// WEBPACK FOOTER //
// src/components/BroadCast/BroadcastProgressPopup.vue